import theme from '../../../lib/theme';
import { ProviderCTAProps } from './ProviderCTA';

const {
  colors,
  corners,
  scale,
  layouts,
  shadows,
  media
} = theme;

export default ({
  providerLogoURL 
}: ProviderCTAProps) => ({
  container: {
    ...layouts.column,
    width: '100%',
    backgroundColor: colors.white,
    color: colors.black,
    boxShadow: shadows.highest,
  },
  content: {
    ...layouts.column,
    position: 'relative',
  },
  text: {},
  banner: {
    width: '100%',

    '> img': {
      width: '100%',
      height: 'auto',
    },
  },
  logo: {
    position: 'absolute',
    top: -60,
    width: 90,
    height: 90,
    backgroundImage: `url('${providerLogoURL}')`,
    backgroundColor: colors.white,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    borderRadius: corners.m,
    border: `2px solid ${colors.light_grey}`,
  },
  cta: {
    position: 'absolute !important',
    bottom: 0,
    transform: 'translateY(50%)',
    right: scale.m
  },
});
